// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ce2m","right":"styles_right__1t-iE"};